<template>
  <div class="hpProductsWrap py-3xl">

    <div style="padding-left:10vw;padding-right:10vw;">
      <span class="hpSecTitle">Product Catalog</span>
    </div>
    <div class="hpSecSub">      
      <router-link :to="getCatalogLink">
        EXPLORE MIS PRODUCTS  - <span>VIEW CATALOG</span>
      </router-link>
    </div>
    <div :class="['hpProducts']" style="padding-left:10vw;padding-right:10vw;" @mouseleave="activeIndex = -1"><!-- , 'mx-2xl' -->

      <ul>
        <li v-for="(item,index) in itemsData" :key="'product_'+index">
          <router-link :to="item.url" class="hppContents">
            <div class="hppImgWrap"><img :src="'https://www.mis-implants.com/upload/catalog/products/thumbs/'+item.img+'.png'"></div>
            
            <div class="hppTitleWrap">
              <img class="hppIcon" :src="getCatalogIconURL(index)">
              <div class="hppTitle">                
                <span class="subtitle __hpFont1">
                    <!-- {{item.title}} -->
                    {{titles[index]}}
                  </span>
                <span class="title __hpFont15">{{item.subtitle}}</span>
              </div>        
            </div>

          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    sectionData:{},
    children: {
      type: Array,
      required: true
    },
    size: String
  },
  components: { },
  data() {
    return {
      titles:['Implant Systems','Kits and Tools','Prosthetic Options','MGUIDE'],
      icons:["imp.png","kit.png","prosthetic.png","mguide.png"],
      activeIndex: -1,
        ___itemsData:
        [
          {
            "title":"Implant Systems",
            "subtitle":"V3 Implant",
            "url":"",
            "img":"https://www.mis-implants.com/upload/catalog/products/large/V3-13330.png"
          },
                    {
            "title":"Prosthetic Options",
            "subtitle":"Thin impression coping",
            "url":"",
            "img":"https://www.mis-implants.com/upload/catalog/products/large/VN-IO401.png"
          },
          {
            "title":"MGUIDE",
            "subtitle":"MGUIDE value pack",
            "url":"",
            "img":"https://www.mis-implants.com/upload/catalog/products/large/MG-TMP10.png"
          }

        ]      
    };
  },
  mounted() {
    //console.log("$device > ", this.$device);
  },
  computed: {
    ...mapGetters(["localeString"]),
    getCatalogLink()
    {
      return this.parsedLocaleString+"/product-catalog";
        //<router-link :to="getCatalogLink"><!-- :to="`${parsedLocaleString}/product-catalog`" -->
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    itemsData()
    {
      return this.sectionData.items;
    },
    //...mapState(["dimensions"]),
    parsedChildren() {
      return _.filter(this.children, "url");
    }
  },
  methods: {
    getCatalogIconURL(index)
    {
        var iconFileName = this.icons[index];
        var iconUrl = "img/catalog/"+iconFileName;
        return iconUrl;
    },
    activateItem: _.debounce(function(index) {
      this.activeIndex = index;
    }, 300)
  }
};
</script>

<style scoped>
    @media screen and (max-width: 815px) {
        .hpProductsWrap
        {
          width: 100vw;
          overflow: hidden;
        }
    }  
</style>
<style lang="stylus" scoped>
.hppIcon
  width 34px
  height auto
  float left
  margin 10px 10px 10px 20px
.hpSecTitle
    color #fff !important    
.hpProductsWrap
  background-color #05283c
  .hpSecSub
    a
      color #fff
  .hpProducts
    width 100%
    padding-bottom 40px
    +below(815px)
      padding-left 10vw
      padding-right 10vw
      padding-bottom 0px
      overflow-x scroll
      scroll-snap-type x mandatory
      -webkit-overflow-scrolling touch
      -ms-overflow-style none
      scrollbar-width none
    ul      
      padding-top 55px
      margin-block 0px
      display grid
      list-style none
      grid-template-columns repeat(4, 1fr)
      height auto
      width 100%
      +below(815px)
        width 80vw        
      column-gap 20px
      li        
        +below(815px)
          width 80vw 
          height auto       
          scroll-snap-align center
        position relative
        top 0px
        height 15vw        
        width 100%
        display flex
        flex-flow row wrap
        row-gap 0px        
        transition all ease 0.4s           
        &:hover
          .hppTitleWrap
            background-color #f9f9f9
            .hppTitle
              .subtitle
                color #05283c
              .title
                color #05283c
              
        .hppContents
          width 100%
          clear both
          display block
          text-align center
          .hppImgWrap
            width 100%
            background-color #f9f9f9
            img
              height 10vw
              width auto
              margin auto
              +below(815px)
                height 65vw
                width 100%
                margin auto
                object-fit contain
          .hppTitleWrap
            margin auto
            padding-top clamp(8px, 0.6vw, 20px)
            height 100px
            max-width 100%
            transition all ease 1s
            width 100%
            //padding-top 0px
            .hppTitle
              font-size 13px
              width calc(100% - 80px)
              float left
              padding-top 4px
              display inline-block
              position relative
              color #f9f9f9
              text-align left
              span
                display inline-block
              .subtitle
                font-size 13px
                font-weight 500 !important
                text-transform uppercase
                transition all ease 0.4s  
                display block
              .title
                font-weight 200 !important
                letter-spacing -0.5px !important   
                transition all ease 0.4s   
                display block
                padding-top 3px
</style>


